import React from 'react'
import RegisterComponent from '../components/register/Register.Component';

const RegisterPageComponent = () => {
  return (
    <RegisterComponent />
  )
}

export default RegisterPageComponent